<template>
	<div class="ca-documents">

		<h3 class="title title-page text-primary font-medium">Documents</h3>

		<div class="md-layout md-gutter">
			<user-public-documents-card
				title="Documents privés"
				icon="lock"
				:sites="userDocuments"
			/>
		</div>

		<div class="md-layout md-gutter">
			<global-documents-card
				title="Documents"
				icon="folder-open"
				:documents="globalDocuments"
			/>
		</div>

	</div>
</template>

<script>
import UserPublicDocumentsCard from "@/components/ClientsArea/Documents/UserPublicDocumentsCard";
import GlobalDocumentsCard from "@/components/ClientsArea/Documents/GlobalDocumentsCard";

export default {
	name: "ClientsAreaDocuments",
	components: {
        UserPublicDocumentsCard,
        GlobalDocumentsCard
	},
	data() {
		return {
			userDocuments: [],
            globalDocuments: []
		}
	},
    methods: {
	    async fetchUserPublicDocuments() {
            const localStorageData = JSON.parse(localStorage.getItem('client-area'))
            const { data } = await this.$store.dispatch('clientArea/fetchUserPublicDocuments', {
                    access_token: localStorageData.accessToken,
                    user_type: localStorageData.userType,
                }
            );
            this.userDocuments = data
        },
	    async fetchGlobalDocuments() {
            const localStorageData = JSON.parse(localStorage.getItem('client-area'))
            const { data } = await this.$store.dispatch('clientArea/fetchGlobalDocuments', {
                    access_token: localStorageData.accessToken,
                    user_type: localStorageData.userType,
                }
            );
            this.globalDocuments = data
        }
    },
    mounted() {
        this.fetchUserPublicDocuments()
	    this.fetchGlobalDocuments()
    }
}
</script>

<style scoped>

</style>
